<template>
  <Layout>
    <div class="is-size-7 p-md">
      <div class="has-text-centered" style="margin:auto;max-width:600px;">
        <p><img src="static/kyfbanner.png" class="image" style="margin:auto;"></p>
        <div v-if="carrier == ''">
          <p class="is-size-5 has-text-primary">Tehokkaimmat kuntoharjoitukset vain sinulle! Tilaa valitsemalla matkapuhelinoperaattorisi </p>
          <p><button class="button is-primary is-size-3 m-t-sm" style="width:80%;max-width:480px;" @click="carrier = 'Telia'">Telia</button></p>
          <p><button class="button is-primary is-size-3 m-t-sm" style="width:80%;max-width:480px;" @click="carrier = 'Saunalahti'">Saunalahti</button></p>
          <p><button class="button is-primary is-size-3 m-t-sm" style="width:80%;max-width:480px;" @click="carrier = 'Elisa'">Elisa</button></p>
        </div>
        <form v-else-if="isMsisdn" method="POST" action="#" @submit.prevent="isMsisdn = false">
          <p class="is-size-5 has-text-primary">Tehokkaimmat kuntoharjoitukset vain sinulle! Tilaaksesi lisää matkapuhelinnumerosi </p>
          <div class="m-md">
            <input type="text" v-model="msisdn" class="input is-primary m-r-md is-size-3" style="width:100%;" placeholder="Muoto: 600500400">
            <input type="hidden" name="msisdn" :value="fullMsisdn">
          </div>
          <div class="is-size-5 checkbox">
            <input v-model="terms" type="checkbox" class="checkbox" style="width:40px;height:40px;border-radius:5px;border:2px solid #555;"> 
            <span style="position:relative;top:-10px;line-height:1.5;">5e/vko kestotilaus. Sinun pitää olla liittymän omistaja tai oikeutettu tilaamaan palvelu. </span>
          </div>
          <div>
            <input :disabled="isSubmitEnabled" type="submit" class="button is-primary is-size-3 m-t-sm p-l-xl p-r-xl" value="Lataa">
          </div>
        </form>
        <div v-else-if="carrier == 'Telia'">
          <p class="is-size-5 has-text-primary">Tehokkaimmat kuntoharjoitukset vain sinulle! Anna vastaanotettu PIN-koodi </p>
          <div class="m-md">
            <input type="text" v-model="pin" class="input is-primary m-r-md is-size-3" style="width:100%;" placeholder="PIN: 1234">
          </div>
          <div>
            <input :disabled="isPinEnabled" type="submit" class="button is-primary is-size-3 m-t-sm p-l-xl p-r-xl" value="Jataa">
          </div>
        </div>
        <div v-else>
          <p class="is-size-5 has-text-primary">Tehokkaimmat kuntoharjoitukset vain sinulle! </p>
          <div class="m-md">
            <a href="sms:17XXX?body=OK" class="button is-primary is-size-3 m-t-sm p-l-xl p-r-xl">Lähetä OK numeroon 17XXX</a>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'
import GameTile from '@/components/LangGG/GameTile'

export default {
  name: 'Home',
  components: {
    Layout,
    GameTile
  },
  data () {
    return {
      isMsisdn: true,
      msisdn: '',
      carrier: '',
      terms: false,
      pin: '',
      game: {
        name: 'Furious Red Riding Hood',
        path: 'https://assets.gamega.me/cn/fndxhm/index.html',
        icon: 'https://assets.gamega.me/cn/fndxhm/sqricon.jpg',
        tags: [ 'Adventure', 'Plataform' ],
        votes: 19,
        score: 3.736842105263158,
        id: 1
      }
    }
  },
  computed: {
    hasValidMsisdn () {
      return this.msisdn.match(/^(00358|0|\+358|358)?([1-9][0-9]+)/) instanceof Array
    },
    isSubmitEnabled () {
      return !(this.hasValidMsisdn && this.terms)
    },
    isPinEnabled () {
      return ! this.pin.match(/^([0-9]+)$/) instanceof Array
    },
    fullMsisdn () {
      return this.msisdn.replace(/^(00358|0|\+358|358)?([1-9][0-9]+)/, '00358$2')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangKyf/FI/LP.vue